/**
 * Enum representing all possible types for supported events
 */
export var BackendEventType;
(function (BackendEventType) {
    BackendEventType["Start"] = "start";
    BackendEventType["End"] = "end";
    BackendEventType["Input"] = "input";
    BackendEventType["Output"] = "output";
    BackendEventType["Sleep"] = "sleep";
    BackendEventType["Error"] = "error";
    BackendEventType["Interrupt"] = "interrupt";
    BackendEventType["Loading"] = "loading";
    BackendEventType["Frame"] = "frame";
    BackendEventType["FrameChange"] = "frame-change";
    BackendEventType["Stop"] = "stop";
})(BackendEventType || (BackendEventType = {}));
//# sourceMappingURL=BackendEvent.js.map